import getStore from "../store/store";
import { mutatorAction } from "satcheljs";

const setBackgroundColorMutator: (color: string) => void = mutatorAction("setAppBackgroundColor", (color: string): void => {
    getStore().backgroundColor = color;
});
export default setBackgroundColorMutator;
